export default "__VITE_ASSET__Bk$BJsnk__"